import React, { useState, useEffect, useRef } from "react";
import { Paper, BottomNavigation, BottomNavigationAction } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import LoginIcon from "@mui/icons-material/Login";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext.js";

const MainMenu = ({ headerHeight = 0, isMobile = false }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(0);
  const navRef = useRef(null);

  // 🔄 Synchroniser l’onglet actif avec l’URL
  useEffect(() => {
    const path = location.pathname || "/";
    if (path === "/") setValue(0);
    else if (path.startsWith("/connexion")) setValue(1);
    else if (path.startsWith("/creation")) setValue(2);
    else setValue(0);
  }, [location.pathname]);

  // Navigation
  const handleNavigation = (newValue) => {
    switch (newValue) {
      case 0:
        navigate("/");
        break;
      case 1:
        navigate("/connexion");
        break;
      case 2:
        navigate("/creation");
        break;
      default:
        navigate("/");
    }
  };

  return (
    <Paper
      ref={navRef}
      className="main-menu"
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        zIndex: 10,
        borderTop: "1px solid #ccc",
        /*bottom: isMobile ? 0 : "auto",
        top: isMobile ? "auto" : `${headerHeight}px`,*/
        ...(isMobile
    ? { bottom: 0, top: "auto" } // ✅ collé en bas
    : { top: `${headerHeight}px`, bottom: "auto" } // ✅ sous le header
  )
      }}
      elevation={3}
    >
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => handleNavigation(newValue)}
        showLabels
        sx={{
          backgroundColor: "#e4dcd2",
          color: "white",
          "& .Mui-selected": { color: "#3399FF" },
        }}
      >
        <BottomNavigationAction value={0} label={t("Home")} icon={<HomeIcon />} />
        <BottomNavigationAction value={1} label={t("ConnectToAGroup")} icon={<LoginIcon />} />
        <BottomNavigationAction value={2} label={t("CreateNewGroup")} icon={<GroupAddIcon />} />
      </BottomNavigation>
    </Paper>
  );
};

export default MainMenu;
